// el.call('htmlToPlainText', str) — a one-line plain-text reading of a string
// that may carry HTML.
//
// A notification showed its markup: `<p>Global Tech Weekend is an
// international…` (measured live on /inbox and in the bell, 2026-09-21). A
// calendar invitation carries the event description, and a Google Calendar
// description is HTML. Every site prints it through `text:`, so it is safe —
// and wrong: the reader sees the tags.
//
// THE OUTPUT IS TEXT, ALWAYS. Never hand it to `html:`. That is what makes
// decoding an entity safe here: `&lt;script&gt;` becomes the four characters a
// person typed, painted as characters.
//
// A tag starts with a LETTER right after `<` (or `</`), so a bare comparison
// in prose (`a < b and c > d`) is left alone. A block end and a <br> become one
// space, so two paragraphs never glue into one word.
//
// FA204 — self-contained on purpose: the entity table lives inside the
// function, the same discipline longPress.js and openInSlot.js follow.
//
// `{ breaks: true }` keeps the PARAGRAPHS for a detail view: a block end and a
// <br> become a newline instead of a space (pair it with `whiteSpace:
// 'pre-line'`). The default is the one-line preview a list row needs.
export const htmlToPlainText = function (input, opts) {
  if (typeof input !== 'string' || !input) return ''
  if (input.indexOf('<') === -1 && input.indexOf('&') === -1) return input.trim()
  const breaks = !!(opts && opts.breaks)
  const ENTITIES = {
    nbsp: ' ',
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    mdash: '—',
    ndash: '–',
    hellip: '…',
    rsquo: '’',
    lsquo: '‘',
    rdquo: '”',
    ldquo: '“'
  }
  return input
    .replace(/<\s*br\s*\/?\s*>|<\/\s*(p|div|li|tr|h[1-6]|blockquote)\s*>/gi, breaks ? '\n' : ' ')
    .replace(/<\/?[a-zA-Z][^>]*>/g, '')
    .replace(/&#(\d+);/g, (m, code) => String.fromCodePoint(Number(code)))
    .replace(/&([a-zA-Z]+);/g, (m, name) =>
      Object.prototype.hasOwnProperty.call(ENTITIES, name.toLowerCase())
        ? ENTITIES[name.toLowerCase()]
        : m
    )
    .replace(breaks ? /[^\S\n]+/g : /\s+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
